import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from "luxon";
import {CCRolesType} from "./cc-roles-type";
import {WebUserSettings} from "./user-settings";

export class UserAccount {
  @JsonProperty()
  login: string | undefined;
}

export class UserPreferences {
  @JsonProperty()
  lang: string | undefined;
}

export class User {

  @JsonProperty()
  username: string | undefined;

  @JsonProperty()
  originUsername: string | undefined;

  @JsonProperty()
  originForceChangePassword: boolean = true;

  @JsonProperty()
  password: string | undefined;

  @JsonProperty()
  currentPassword: string | undefined;

  @JsonProperty()
  confirmPassword: string | undefined;

  @JsonProperty()
  origine: string | undefined;

  @JsonProperty()
  forceChangePassword: boolean = true;

  @JsonProperty()
  enabled: boolean;

  @JsonProperty()
  lastConnectionDate: DateTime;

  @JsonProperty()
  badPasswordCount: number = 0;

  @JsonProperty()
  changePasswordDate: DateTime;

  @JsonProperty()
  accountExpired: boolean = false;

  @JsonProperty()
  accountLocked: boolean = false;

  @JsonProperty()
  passwordHistory: string | undefined;

  @JsonProperty()
  firstName: string | undefined;

  @JsonProperty()
  lastName: string | undefined;

  @JsonProperty()
  language: string | undefined;

  @JsonProperty()
  country: string | undefined;

  @JsonProperty()
  email: string | undefined;

  @JsonProperty()
  jobTitle: string | undefined;

  @JsonProperty()
  webUserSettings: WebUserSettings | undefined;

  @JsonProperty({type: UserPreferences})
  preferences: UserPreferences | undefined;
  @JsonProperty({type: UserAccount})
  account: UserAccount | undefined;
  @JsonProperty()
  lang: string | undefined;
  @JsonProperty()
  roles: CCRolesType.Roles[] | undefined;

  @JsonProperty()
  notifActionTypesJs: string[];
  @JsonProperty()
  userGroupNames: string[];

  constructor(userFromDb?: any) {
    if (userFromDb) {
      this.username = userFromDb.username;

      // Comes from local storage - Build the user normally
      const attributes = ['account', 'preferences'];
      for (const att of attributes) {
        if (userFromDb[att]) {
          for (const key of Object.keys(userFromDb[att])) {
            // @ts-ignore
            this[att][key] = userFromDb[att][key];
          }
        }
      }
    }
  }
}
